module.exports = __webpack_public_path__ + "0f6e71c2b347b9e1e86906c84c95cd7c.svg";